import { render, staticRenderFns } from "./capacityConfigDashboard.vue?vue&type=template&id=291b79d7&scoped=true"
import script from "./capacityConfigDashboard.vue?vue&type=script&lang=js"
export * from "./capacityConfigDashboard.vue?vue&type=script&lang=js"
import style0 from "./capacityConfigDashboard.vue?vue&type=style&index=0&id=291b79d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291b79d7",
  null
  
)

export default component.exports